import {useSelector} from 'react-redux';
import {IRootState} from 'app/shared/reducers';
import {RegionDescriptionType} from 'app/shared/model/enumerations/region-description-type.model';

// Default fallback labels
const DEFAULT_LABELS: Record<RegionDescriptionType, string> = {
  [RegionDescriptionType.REGION]: 'Region',
  [RegionDescriptionType.DISTRICT]: 'District',
  [RegionDescriptionType.COUNCIL]: 'Council',
  [RegionDescriptionType.VILLAGE]: 'Village',
};

export const useRegionLabels = () => {
  const regionDescriptions = useSelector((state: IRootState) => state.authentication.regionDescriptions);
  const isLoading = useSelector((state: IRootState) => state.authentication.loading);

  const getLabel = (regionType: RegionDescriptionType): string => {
    if (!regionDescriptions || regionDescriptions.length === 0) {
      return DEFAULT_LABELS[regionType];
    }

    const description = regionDescriptions.find(rd => rd.regionType === regionType);
    return description?.enDesc || DEFAULT_LABELS[regionType];
  };

  const getAllLabels = (): Record<RegionDescriptionType, string> => {
    const labels = {} as Record<RegionDescriptionType, string>;
    // Manually iterate through enum values to avoid const enum issues
    const enumValues = [
      RegionDescriptionType.REGION,
      RegionDescriptionType.DISTRICT,
      RegionDescriptionType.COUNCIL,
      RegionDescriptionType.VILLAGE
    ];

    enumValues.forEach(type => {
      labels[type] = getLabel(type);
    });
    return labels;
  };

  return {
    getLabel,
    getAllLabels,
    isLoading,
    hasCustomLabels: regionDescriptions && regionDescriptions.length > 0
  };
};

export default useRegionLabels;
